var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTruckRamp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M416.008 0C380.661 0 352.008 28.654 352.008 64V355.611L5.894 449.982C1.644 451.232 -0.856 455.607 0.269 459.732L12.894 506.105C14.144 510.355 18.519 512.855 22.769 511.73L416.381 404.234C418.851 466.516 471.637 515.812 535.342 511.746C595.327 507.917 640 453.993 640 393.885L640 0H416.008ZM528.004 447.982C501.504 447.982 480.004 426.484 480.004 399.984C480.004 373.486 501.504 351.986 528.004 351.986C554.502 351.986 576.002 373.486 576.002 399.984C576.002 426.484 554.502 447.982 528.004 447.982Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckRamp);
export default __webpack_public_path__ + "static/media/truck-ramp.991efe5c640b5272c4b29999f6cfa611.svg";
export { ForwardRef as ReactComponent };